<template>
  <div class="type-of-review wrap-content">
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label" style="margin-bottom:20px">送审季度设置</label>
        <Form style="width: 300px">
          <FormItem label="送审年份：" prop="year" style="margin-bottom:20px">
            <label>
              <Select v-model="configData.auditYear" style="width:200px">
                <Option v-for="item in yearOption" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </label>
          </FormItem>
          <FormItem label="送审季度：" prop="quarter" style="margin-bottom:20px">
            <label>
              <Select v-model="configData.seasonName" style="width:200px">
                <Option v-for="item in quarterOption" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </label>
          </FormItem>
        </Form>
        <Button type="primary" @click="flag && saveConfig()">保存配置</Button>
      </div>
    </div>
  </div>
</template>

<script>
// 评阅类型配置
export default {
  name: 'typeOfReview',
  data () {
    return {
      flag: true,
      yearOption: [
      ],
      quarterOption: [{
        value: '第一季度',
        label: '第一季度'
      }, {
        value: '第二季度',
        label: '第二季度'
      }, {
        value: '第三季度',
        label: '第三季度'
      }, {
        value: '第四季度',
        label: '第四季度'
      }],
      configData: {
        auditYear: new Date().getFullYear(),
        seasonName: '第一季度'
      }
    }
  },
  created () {
    const _self = this;
    _self.fetchMaterialConfig();
    // let start = Number(_self.configData.auditYear) - 2;
    // while (start <= Number(_self.configData.auditYear) + 2) {
    //   _self.yearOption.push({
    //     value: start,
    //     label: start + '年'
    //   });
    //   start = start + 1;
    // }
  },
  watch: {
    'configData.auditYear': {
      handler (val) {
        // const _self = this;
        // _self.yearOption = [];
        // let start = Number(val) - 2;
        // while (start <= Number(val) + 2) {
        //   start = start + 1;
        //   _self.yearOption.push({
        //     value: start,
        //     label: start + '年'
        //   });
        // }
        // console.log(_self.yearOption);
      }
    }
  },
  methods: {
    fetchMaterialConfig () {
      this.post('/school/schoolQuarter/getCurrentSchoolSeason').then(res => {
        console.log(typeof (res.data.auditYear))
        let nowYear = Number(new Date().getFullYear())
        let auditYear = Number(res.data.auditYear)
        this.yearOption = [
          {value: nowYear - 5, label: nowYear - 5 + '年'},
          {value: nowYear - 4, label: nowYear - 4 + '年'},
          {value: nowYear - 3, label: nowYear - 3 + '年'},
          {value: nowYear - 2, label: nowYear - 2 + '年'},
          {value: nowYear - 1, label: nowYear - 1 + '年'},
          {value: nowYear, label: nowYear + '年'},
          {value: nowYear + 1, label: (nowYear + 1) + '年'}
        ]
        this.configData.auditYear = auditYear
        this.configData.seasonName = res.data.seasonName
        this.configData.id = res.data.id
        this.configData.schoolId = res.data.schoolId
        this.configData.sign = 1
      });
    },
    postConfig (param) {
      this.post('/school/schoolQuarter/setCurrentSchoolSeason', param).then(res => {
        if (this.flag && res.code === 200) {
          this.$Message.success('保存成功')
          this.flag = false
          let _self = this
          setTimeout(function () {
            _self.flag = true
          }, 1000)
        }
      })
    },
    saveConfig () {
      let param = {
        schoolId: this.configData.schoolId,
        auditYear: this.configData.auditYear,
        seasonName: this.configData.seasonName,
        sign: this.configData.sign
      }
      this.postConfig(param)
    }
  },
  activated () {
  }
}
</script>

<style lang="less" scoped>
  .type-of-review{
    .wrap-form-item {
      height: 32px;
      line-height: 32px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/configManage/quarterOfReview.vue